module.exports = __webpack_public_path__ + "static/media/down.8d89ab77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.svg
// module id = 37
// module chunks = 0